import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const ShoppingCartIcon24: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <g>
            <path
                fillRule="evenodd"
                d="M21.516 1.878a.75.75 0 0 0-.74.624l-2.637 15.5a2.25 2.25 0 0 1-2.218 1.873H6a.75.75 0 0 1 0-1.5h9.92a.75.75 0 0 0 .74-.625l.405-2.375.255-1.5 1.276-7.504.256-1.5.445-2.62A2.25 2.25 0 0 1 21.517.377h.984a.75.75 0 0 1 0 1.5h-.984ZM7.08 20.954a1.125 1.125 0 1 1 1.59 1.592 1.125 1.125 0 0 1-1.59-1.592ZM15.375 20.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM6 7.875a.75.75 0 0 1 .75.75v2.25a.75.75 0 1 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75ZM10.5 7.875a.75.75 0 0 1 .75.75v2.25a.75.75 0 1 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Z"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M15 7.875a.75.75 0 0 1 .75.75v2.25a.75.75 0 1 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75Z"
                clipRule="evenodd"
            />
            <path d="M2.25 4.87A1.5 1.5 0 0 0 .794 6.736l1.45 5.8a3.75 3.75 0 0 0 3.638 2.84h11.183l.255-1.5H5.882A2.25 2.25 0 0 1 3.7 12.17l-1.45-5.8h16.346l.256-1.5H2.25Z" />
        </g>
    </SvgIcon>
);
